import { graphql } from 'react-apollo'

import { ModalActionTypes } from '@acorns/web-components'
import { compose, withProps } from 'recompose'

import withHeroText, { HeroTextProps } from 'components/HOCs/withHeroText'
import withRemoteStrings, { RemoteStringsProps } from 'components/HOCs/withRemoteStrings'
import { withApolloErrorModal } from 'utils/Apollo/apolloErrorHandlingProvider'

import PersonalInfo from '../Shared'
import { PersonalInfoProps } from '../Shared/types'
import withPersonalInfo from '../Shared/withPersonalInfo'
import formRows, { handleSubmit } from './form'
import updatePersonalInfo from './gql/updatePersonalInfo.mutation.gql'

type Props = PersonalInfoProps & HeroTextProps & RemoteStringsProps

export const enhance = compose<Props, {}>(
  withHeroText,
  withRemoteStrings,
  withApolloErrorModal,
  graphql(updatePersonalInfo, { name: 'updatePersonalInfo' }),
  withPersonalInfo({
    handleSubmit,
    showPhoneNumber: true,
    showNames: false,
  }),
  withProps(({ data, handleCloseModal, values, heroText }) => {
    const requiredFields = Object.values(values).filter((_, index) => index !== 4)
    return {
      rows: formRows(data),
      actions: [
        {
          label: 'Ok',
          type: ModalActionTypes.primary,
          handler: handleCloseModal,
        },
      ],
      valid: requiredFields.every(Boolean),
      loading: data.loading,
      header: heroText.header,
      text: heroText.text,
      footnote: heroText.footnote,
      footnoteLock: heroText.footnoteLock,
      submitCta: 'Next',
    }
  }),
)

export default enhance(PersonalInfo)
